import React, { useEffect, useState, useCallback } from "react";
import "./ContactModal.css";

export default function ContactModal({ isOpen, onClose }) {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = useCallback(() => {
    console.log("Closing modal...");
    setIsClosing(true);
    setTimeout(() => {
      console.log("Modal closed");
      setIsClosing(false);
      onClose();
    }, 300);
  }, [onClose]);

  // Close modal on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      // Prevent background scrolling
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, handleClose]);

  // Reset closing state when modal opens
  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);

  if (!isOpen && !isClosing) return null;

  console.log("Modal render:", { isOpen, isClosing });

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div
      className={`contact-modal-overlay ${isClosing ? "closing" : ""}`}
      onClick={handleOverlayClick}
    >
      <div className={`contact-modal ${isClosing ? "closing" : ""}`}>
        <button className="modal-close-button" onClick={handleClose}>
          ×
        </button>

        <div className="modal-header">
          <h2>Get in Touch</h2>
          <p>Let's discuss your next project or collaboration</p>
        </div>

        <div className="contact-content">
          <div className="contact-methods">
            <div className="contact-method">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                  />
                  <polyline
                    points="22,6 12,13 2,6"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
              </div>
              <div className="contact-info">
                <h3>Email</h3>
                <a href="mailto:charlesdavid@mupende.com">
                  charlesdavid@mupende.com
                </a>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
              </div>
              <div className="contact-info">
                <h3>Phone</h3>
                <a href="tel:+491794157744">+49 179 4157744</a>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                    fill="currentColor"
                  />
                  <rect x="2" y="9" width="4" height="12" fill="currentColor" />
                  <circle cx="4" cy="4" r="2" fill="currentColor" />
                </svg>
              </div>
              <div className="contact-info">
                <h3>LinkedIn</h3>
                <a
                  href="https://www.linkedin.com/in/charlesmupende/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  linkedin.com/in/charlesmupende
                </a>
              </div>
            </div>

            <div className="contact-method">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
              </div>
              <div className="contact-info">
                <h3>GitHub</h3>
                <a
                  href="https://github.com/bandundu"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  github.com/bandundu
                </a>
              </div>
            </div>
          </div>

          <div className="contact-cta">
            <p>
              I'm always interested in new opportunities and collaborations.
            </p>
            <p>Feel free to reach out!</p>
          </div>
        </div>
      </div>
    </div>
  );
}
